import { render, staticRenderFns } from "./EntradasOtrosComponent.vue?vue&type=template&id=dcf44ba0"
import script from "./EntradasOtrosComponent.vue?vue&type=script&lang=js"
export * from "./EntradasOtrosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports